import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-short-url-resolve',
  standalone: true,
  imports: [],
  template: '',
})
export class ShortUrlResolveComponent implements OnInit {
  private _route = inject(ActivatedRoute);
  private _http = inject(HttpClient);

  ngOnInit(): void {
    const shortId = this._route.snapshot.paramMap.get('shortId');
    if (!shortId) {
      window.location.href = '/error/invalid-url';
      return;
    }

    this._http
      .get<{ redirectUrl: string }>(
        `${environment.apiUrl}api/d/${shortId}`
      )
      .subscribe({
        next: (res) => {
          window.location.href = res.redirectUrl;
        },
        error: () => {
          window.location.href = '/error/invalid-url';
        },
      });
  }
}
